import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ConfirmComponent } from "../componentes/dialog/confirm/confirm.component";

@Injectable({
  providedIn: "root",
})
export class DialogService {
  constructor(private dialog: MatDialog) {}

  confirm(titulo: string, texto: string) {
    return new Promise((resolve, reject) => {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      dialogConfig.data = {
        titulo,
        texto,
      };
      const dialogRef = this.dialog.open(ConfirmComponent, dialogConfig);

      dialogRef.afterClosed().subscribe((data) => {
        if (data) {
          resolve(data);
        } else {
          reject(data);
        }
      });
    });
  }
}
